export const environment = {
  production: false,
  apiUrl: 'https://store.kokoro.guru/api/v1',
  adminUrl: 'https://adminapi.kokoro.guru',
  homeCareApiUrl: 'https://care.kokoro.guru/api/v1',
  ticketApiUrl: 'https://ticket.kokoro.guru/api/v1',
  productMatchingApiUrl: 'https://prdes.kokoro.guru/api/v1',
  googleMapsApiKey: 'AIzaSyCI_mpTR5O10P4ZT6Qzz3OHVB--G6uKHsE',
};
